import { setURL } from '@/api/apiUtil'

export default {
  // 查詢事件紀錄
  getEventLogList: {
    url: '/WebAPI/api/EventLog/list',
    method: 'get'
  },
  // 設備註冊WebSocket取token
  addWebSocketSubscript: {
    url: '/WebSocketAPI/api/WebSocket/addSubscript',
    method: 'post'
  },

}